import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Building2, Mail, Users, ArrowRight, UserCircle, FileSpreadsheet } from "lucide-react";

const tiles = [
  {
    to: "/profil",
    icon: UserCircle,
    title: "Mein Profil",
    desc: "Eigene E-Mail-Adresse und Passwort ändern.",
    testid: "settings-tile-profil",
    color: "bg-emerald-500/10 text-emerald-500",
  },
  {
    to: "/team",
    icon: Users,
    title: "Team",
    desc: "Admins, Innendienst und Monteure anlegen, Rollen und Passwörter verwalten.",
    testid: "settings-tile-team",
    color: "bg-orange-500/10 text-orange-500",
  },
  {
    to: "/auftraggeber",
    icon: Building2,
    title: "Auftraggeber",
    desc: "Kunden verwalten und Portal-Zugänge (Login) für Auftraggeber anlegen oder ändern.",
    testid: "settings-tile-auftraggeber",
    color: "bg-primary/10 text-primary",
  },
  {
    to: "/import",
    icon: FileSpreadsheet,
    title: "Excel-Import",
    desc: "Bestehende Kundenlisten aus Excel/CSV in Auftraggeber, Anmeldungen und Projekte importieren.",
    testid: "settings-tile-import",
    color: "bg-violet-500/10 text-violet-500",
  },
  {
    to: "/email-einstellungen",
    icon: Mail,
    title: "E-Mail-Anbindung",
    desc: "Gmail/IMAP-Verbindung für den Posteingang konfigurieren.",
    testid: "settings-tile-email",
    color: "bg-sky-500/10 text-sky-500",
  },
];

export default function Einstellungen() {
  return (
    <div className="p-4 lg:p-8 space-y-6 animate-fade-up" data-testid="einstellungen-page">
      <div>
        <div className="overline">Verwaltung</div>
        <h1 className="font-heading text-3xl lg:text-4xl font-bold tracking-tight mt-2">Einstellungen</h1>
        <p className="text-muted-foreground mt-1">Zugänge, Kunden und Integrationen an einem Ort.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {tiles.map(({ to, icon: Icon, title, desc, testid, color }) => (
          <Link key={to} to={to} data-testid={testid}>
            <Card className="border-border hover:border-primary/60 hover:shadow-sm transition-all cursor-pointer h-full">
              <CardContent className="p-6">
                <div className={`h-12 w-12 rounded-lg flex items-center justify-center ${color}`}>
                  <Icon className="h-6 w-6" />
                </div>
                <div className="font-heading text-xl font-bold tracking-tight mt-4">{title}</div>
                <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{desc}</p>
                <div className="mt-4 inline-flex items-center gap-1 text-xs text-primary">
                  Öffnen <ArrowRight className="h-3 w-3" />
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
